import { PropertyInfoType } from '../../canceled-bond-insurance-list/components/create-cancelation-modal/types/PropertyInfoTypes';

export interface DropdownOptions {
  index: number;
  value: number | string;
  text: string;
}

export type ListRecordsType = {
  id: string;
  name?: string;
  property?: PropertyInfoType;
  company_name?: string;
  cpf?: string;
  cnpj?: string;
  origem: string;
  estate: string;
  insurer?: string;
};

export const typeOptions = [
  {
    index: 1,
    value: 'document',
    text: 'CPF ou CNPJ locatário'
  },
  {
    index: 2,
    value: 'property_document',
    text: 'CPF ou CNPJ proprietário'
  },
  {
    index: 3,
    value: 'name',
    text: 'Nome do locatário'
  },
  {
    index: 4,
    value: 'property_name',
    text: 'Nome do proprietário'
  },
  {
    index: 5,
    value: 'address',
    text: 'Endereço do imóvel'
  },
  {
    index: 6,
    value: 'insurerPolicyId',
    text: 'Código da apólice'
  },
  {
    index: 7,
    value: 'policyId',
    text: 'ID da apólice'
  }
];
